import { useQuery } from '@tanstack/react-query'
import { dictionaryService } from '@/api/services/dictionary.service'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import { queryKeys } from '@/api/query-keys'

/**
 * The school's custom words and student roster. Fetched only while `enabled` (the Spell Check
 * panel is open) and kept fresh by the add/remove mutations and by `useDictionarySync`, which marks
 * it stale when another editor changes the dictionary, so it never refetches on its own.
 */
export function useDictionaryQuery(enabled: boolean) {
  const hasAuth = typeof window !== 'undefined' && Boolean(getWpcauthForExternalApi())

  return useQuery({
    queryKey: queryKeys.dictionary.all,
    queryFn: () => dictionaryService.getDictionary(),
    enabled: enabled && hasAuth,
    staleTime: Infinity,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
